import { SelectField } from "@rawa/ui/SelectField"
import { fieldInstructions, fieldName } from "../fields"
import type { ControlRenderer } from "./types"

// The value is the chosen option's value: its identity, and what anything
// reading the data gets. Choosing none back is no answer.
export const dropdownSingle: ControlRenderer<"dropdownSingle"> = {
  Render: ({ field, value, onChange, error }) => (
    <SelectField
      id={field.id}
      label={fieldName(field)}
      hint={fieldInstructions(field)}
      value={value ?? ""}
      onChange={(chosen) => onChange(chosen === "" ? undefined : chosen)}
      options={field.options.map((option) => ({
        value: option.value,
        label: option.label,
      }))}
      placeholder={field.placeholder || "Choose an option"}
      required={field.required}
      error={error}
    />
  ),
}
